import axios from "axios";

/**
 * Helper para obtener la configuración de axios con headers y baseURL.
 * @param token Token de autenticación.
 * @param urlAxioPP URL base de la API (opcional).
 * @returns Configuración para axios.
 */
const getAxiosConfig = (token: string, urlAxioPP?: string) => {
  const url = urlAxioPP || localStorage.getItem("urlAxioPP") || "";
  return {
    baseURL: url,
    headers: { Authorization: `Bearer ${token}` },
  };
};

/**
 * Obtiene la lista de estudios del paciente.
 * @param token Token de autenticación.
 * @param urlAxioPP URL base de la API (opcional).
 * @returns Array de estudios (puede incluir .text para UI).
 */
export const getEstudiosPaciente = async (token: string, urlAxioPP?: string) => {
  const config = getAxiosConfig(token, urlAxioPP);
  const response = await axios.get(`Estudios`, config);
  // Se puede mapear para UI si es necesario
  return (response.data || []).map((estudio: any) => ({ ...estudio, text: estudio.nombre }));
};

/**
 * Obtiene la lista de servicios del paciente.
 * @param token Token de autenticación.
 * @param urlAxioPP URL base de la API (opcional).
 * @returns Array de servicios.
 */
export const getServiciosPaciente = async (token: string, urlAxioPP?: string) => {
  const config = getAxiosConfig(token, urlAxioPP);
  const response = await axios.get(`Servicios`, config);
  return response.data || [];
};

/**
 * Obtiene la lista de prestadores filtrados por mutual.
 * @param token Token de autenticación.
 * @param mutual Código de mutual (string o number).
 * @param urlAxioPP URL base de la API.
 * @returns Array de prestadores vigentes.
 */
export const getPrestadores = async (token: string, mutual: string | number, urlAxioPP?: string) => {
  const config = getAxiosConfig(token, urlAxioPP);
  const response = await axios.get(`Prestadores?mutuales=${mutual}`, config);
  // Filtra solo prestadores vigentes
  return (response.data || []).filter((p: any) => p.vigente === true);
};

/**
 * Obtiene la lista de especialidades vigentes.
 * @param token Token de autenticación.
 * @param urlAxioPP URL base de la API.
 * @returns Array de especialidades vigentes.
 */
export const getEspecialidades = async (token: string, urlAxioPP?: string) => {
  const config = getAxiosConfig(token, urlAxioPP);
  const response = await axios.get(`Especialidades`, config);
  // Filtra solo especialidades vigentes
  return (response.data || []).filter((e: any) => e.vigente === true);
};
